import { AppState } from "../../common/store/app-state/app-state-slice";
import { device } from "../hooks/use-device-detector";

const getCommonData = (state: AppState) => ({
  su_id: state.suId,
  session_id: state.sessionId,
  conversation_id: state.conversationId,
  merchant_id: state.merchId,
  device_info: device,
  http_referrer: window.location.href,
  landing_page: window.location.href,
  ip_address: state.ipAddress,
  sixth_sense_data: localStorage.getItem("_6senseCompanyDetailsvoa"),
});

export default getCommonData;
